module.exports = __webpack_public_path__ + "static/media/ms-dhoni.7d015b81.jpg";